import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { default_design } from '../static/default_design';
import { Preview } from './UiKit/Preview';
import { setReturnAfterLogin } from './utilsSocial';
import { StateContext } from '../contexts/stateContext';
import { AUTH_MODAL_LOGIN, openAuth } from './utilsAuth';

export function Ad1Chat() {
  const context = { ...useContext(LangContext), ...useContext(StateContext) };
  const $ui = context.$ui;
  const location = useLocation();

  useEffect(() => {
    setReturnAfterLogin(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  const removeLanguageParam = () => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1));
    params.delete('ln');
    const newHash = params.toString();
    window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
  };

  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1));
    const languageParam = params.get('ln');
    if (languageParam !== context.language && context.languages.includes(languageParam)) {
      context.setLanguage(languageParam);
    }
    removeLanguageParam();
  }, [location]);

  return (
    <>
      <div
        className="under_construction under_construction--ad"
        style={{
          zIndex: 1
        }}
      >
        <div className="x_ad_gate0 _fv _fc _fm">
          <div className="x_ad_gate">
            <div className="x_logo">
              HD
              <div style={{
                height: '0.75em',
                lineHeight: '1em',
                width: '0.2em',
                borderBottom: '0.2em solid var(--accent)',
                margin: '0 0.05em',
              }}></div>
              Cafe
            </div>
          </div>
          <div className="x_ad_gate2">
            {$ui('landing_slogan')}
          </div>

          <div className="x_add_calltoaction">
            <a
              href="/auth0/login"
              className="x_ad_cta x_ad_cta--1"
              style={{ position: 'relative' }}
              onClick={(event) => {
                setReturnAfterLogin(`${location.pathname}${location.search}`);
                openAuth(context.setState.setAuthModal, AUTH_MODAL_LOGIN)(event);
              }}
            >
              {$ui('user_signin')}
            </a>
          </div>

          <div className="x_ad_languages0">
            <a
              className={`x_ad_lang ${context.language === 'en' ? 'active' : ''}`}
              onClick={() => context.setLanguage('en')}
            >
              <div>English</div>
            </a>
            <a
              className={`x_ad_lang ${context.language === 'ru' ? 'active' : ''}`}
              onClick={() => context.setLanguage('ru')}
            >
              <div>По-русски</div>
            </a>
          </div>
        </div>
      </div>

      <div
        style={{
          flexDirection: 'column',
          opacity: 0.5,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="_fv _fcc"
          style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0 }}
        >
          <Preview design={default_design} />
        </div>
      </div>
    </>
  );
}
